import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  audioList: [], // Stores the list of audio details
  isLoading: false,
  error: null,
};

const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    setAudioList: (state, action) => {
      state.audioList = action.payload;
    },
    addAudio: (state, action) => {
      state.audioList.push(action.payload);
    },
    removeAudio: (state, action) => {
      state.audioList = state.audioList.filter(
        (audio) => audio.id !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setAudioList, addAudio, removeAudio, setLoading, setError } =
  audioSlice.actions;

export default audioSlice.reducer;
